import React from 'react';
import './text.scss';
const Text = ({ textValue, Class }) => {
  return <p className={Class}>{textValue}</p>;
};

export default Text;
